import { useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';

export default function useCoverMenu({ activityConf, gameActions }) {
  const { state, actions } = useCustomHook({
    defaultState: {
      screen: 'TYPE',
    },
    actions: {
      startGame: () => {
        gameActions.startGame();
      },
    },
  });

  useEffect(() => {
    if (activityConf?.miniactivityType) {
      actions.setState({
        screen: 'START',
      });
    } else {
      actions.setState({
        screen: 'TYPE',
      });
    }
  }, [activityConf]);

  return { state, actions };
}
